import React from 'react';

interface BadgeProps {
    /** Content to display inside the badge */
    children?: React.ReactNode;

    /** Optional callback function when the remove button is clicked */
    onRemove?: () => void;

    /** Optional className for additional styling */
    className?: string;

    /** Optional aria-label for accessibility */
    label?: string;

    /** Optional left icon */
    leftIcon?: string;

    /** Optional right icon */
    rightIcon?: string;

    /** Optional callback function when the left icon is clicked */
    onLeftIconClick?: () => void;

    /** Optional callback function when the right icon is clicked */
    onRightIconClick?: () => void;

    /** Size */
    size?: 'sm' | 'md';

    /** Round */
    round?: boolean;

    /** Color */
    color?: string;
}

const Badge: React.FC<BadgeProps> = ({
    className = '',
    label = '',
    leftIcon,
    rightIcon,
    onLeftIconClick,
    onRightIconClick,
    size = 'md',
    round = false,
    color = 'bg-indigo-800',

}) => {

  const sizeClasses = {
    sm: 'py-1 px-2',
    md: 'py-2 px-3',
  };

  const roundClasses = round ? 'rounded-full' : 'rounded-md';


    return (
        <span
          className={`inline-flex items-center gap-x-1 text-sm font-medium leading-none  text-gray-300 ${color} ${roundClasses} ${sizeClasses[size]} ${className}`}
        >
          {leftIcon && (
            <img
              src={leftIcon}
              alt="left"
              className="w-4 h-4 cursor-pointer"
              onClick={onLeftIconClick}
            />
          )}
          <span>{label}</span>
          {rightIcon && (
            <img
              src={rightIcon}
              alt="right"
              className="w-4 h-4 cursor-pointer"
              onClick={onRightIconClick}
            />
          )}
        </span>
      );
};

export default Badge;
